import type { SVGProps } from 'react'
const SvgSyEnvelopeSolid = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={24} height={24} {...props}>
		<path d="m26.4 149.4 213.2 159.9c4.9 3.6 10.7 5.5 16.5 5.5s11.6-1.8 16.5-5.5l213.2-159.9c10.9-8.2 17.2-20.9 17.2-34.5 0-11.9-4.8-22.7-12.6-30.5s-18.6-12.6-30.5-12.6H52.2c-11.9 0-22.7 4.8-30.5 12.6S9.1 103 9.1 114.9c0 13.6 6.4 26.3 17.2 34.5z" />
		<path d="M256 354c-14.1 0-28.1-4.5-40-13.3L9.1 185.5v195.9c0 16.2 6.6 30.9 17.2 41.5 10.7 10.7 25.3 17.2 41.5 17.2H444c16.2 0 30.9-6.6 41.5-17.2 10.7-10.7 17.2-25.3 17.2-41.5V185.5L295.8 340.7c-11.9 8.9-25.9 13.3-40 13.3z" />
	</svg>
)
export default SvgSyEnvelopeSolid
